
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { UserProfile } from '@/types';

interface ProfileTabContentProps {
  profile: UserProfile;
}

const ProfileTabContent: React.FC<ProfileTabContentProps> = ({ profile }) => {
  return (
    <CardContent className="space-y-5">
      <p className="text-white/95 leading-relaxed">{profile.bio}</p>
      
      <div>
        <h4 className="text-sm font-medium mb-2.5 text-white/95">Genres</h4>
        <div className="flex flex-wrap gap-2">
          {profile.genres.map(genre => (
            <Badge key={genre} variant="secondary" className="bg-neon-purple/20 text-white/95 hover:bg-neon-purple/30 transition-colors border border-neon-purple/30">
              {genre}
            </Badge>
          ))}
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-5 text-sm">
        <div className="p-2.5 rounded-lg bg-black/40 border border-white/20">
          <p className="text-white/85 mb-1 font-medium">Releases</p>
          <p className="font-medium text-white/95">{profile.totalReleases} tracks</p>
        </div>
        <div className="p-2.5 rounded-lg bg-black/40 border border-white/20">
          <p className="text-white/85 mb-1 font-medium">Followers</p>
          <p className="font-medium text-white/95">{profile.followers}</p>
        </div>
      </div>
    </CardContent>
  );
};

export default ProfileTabContent;
